import React, { useContext } from "react";
import PropTypes from "prop-types";

import {
  Title,
  Box,
  Column,
  Field,
  Control,
  Label,
  Input,
  Button,
  Icon
} from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AddBookingForm } from "../../../../components/Bookings";

import { DateInput } from "../../../../components/inputs";
import DaysUsed from "../components/DaysUsed";
import { ModalContext } from "../../../../components/ModalProvider";

function Vacation({ employee, editing, onChange }) {
  const { setModalOpen } = useContext(ModalContext);

  const handleAddPtoClick = () => {
    setModalOpen(
      true,
      <AddBookingForm
        bookingCodeWhere={{ BookingCode_startsWith: "NA" }}
        state={{
          EmployeeRecIdRef: employee.RecId
        }}
        onComplete={() => setModalOpen(false, "")}
      />
    );
  };
  return (
    <div className="employee-tab-container vacation">
      {(employee.VacationDaysAllowedThisYear > 0 ||
        employee.PersonalDaysAllowedThisYear > 0) && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            marginBottom: 15
          }}
        >
          <Field>
            <Control>
              <Button color="primary" size="small" onClick={handleAddPtoClick}>
                <Icon>
                  <FontAwesomeIcon icon="plus" />
                </Icon>
                <span>PTO</span>
              </Button>
            </Control>
          </Field>
        </div>
      )}
      <Box>
        <Title size={4}>Vacation Days</Title>
        <Column.Group>
          <Column size={2}>
            <Field>
              <Control>
                <Label>Days Allowed</Label>
                <Input
                  autocomplete="new"
                  name="VacationDaysAllowedThisYear"
                  readOnly={!editing}
                  type="number"
                  value={employee.VacationDaysAllowedThisYear}
                  onChange={onChange}
                />
              </Control>
            </Field>
          </Column>
          <Column size={4}>
            <DaysUsed
              showBalance
              daysAllowed={employee.VacationDaysAllowedThisYear}
              employeeRecId={employee.RecId}
              endDate={employee.VacationDaysRenewalDate}
              startDate={employee.VacationDayStartDate}
              type="vacation"
            />
          </Column>
          <Column size={2}>
            <Field>
              <Control>
                <Label>Allotment Start Date</Label>
                <DateInput
                  name="VacationDayStartDate"
                  readOnly={!editing}
                  value={employee.VacationDayStartDate}
                  onChange={onChange}
                />
              </Control>
            </Field>
          </Column>
          <Column size={2}>
            <Field>
              <Control>
                <Label>Allotment End Date</Label>
                <DateInput
                  name="VacationDaysRenewalDate"
                  readOnly={!editing}
                  value={employee.VacationDaysRenewalDate}
                  onChange={onChange}
                />
              </Control>
            </Field>
          </Column>
        </Column.Group>
      </Box>
      <hr />
      <Box>
        <Title size={4}>Personal Days</Title>
        <Column.Group>
          <Column size={2}>
            <Field>
              <Control>
                <Label>Days Allowed</Label>
                <Input
                  autocomplete="new"
                  name="PersonalDaysAllowedThisYear"
                  readOnly={!editing}
                  type="number"
                  value={employee.PersonalDaysAllowedThisYear}
                  onChange={onChange}
                />
              </Control>
            </Field>
          </Column>
          <Column size={4}>
            <DaysUsed
              showBalance
              daysAllowed={employee.PersonalDaysAllowedThisYear}
              employeeRecId={employee.RecId}
              endDate={employee.PersonalDaysRenewalDate}
              startDate={employee.PersonalDayStartDate}
              type="sick"
            />
          </Column>

          <Column size={2}>
            <Field>
              <Control>
                <Label>Allotment Start Date</Label>
                <DateInput
                  name="PersonalDayStartDate"
                  readOnly={!editing}
                  value={employee.PersonalDayStartDate}
                  onChange={onChange}
                />
              </Control>
            </Field>
          </Column>
          <Column size={2}>
            <Field>
              <Control>
                <Label>Allotment End Date</Label>
                <DateInput
                  name="PersonalDaysRenewalDate"
                  readOnly={!editing}
                  value={employee.PersonalDaysRenewalDate}
                  onChange={onChange}
                />
              </Control>
            </Field>
          </Column>
        </Column.Group>
      </Box>
    </div>
  );
}

Vacation.propTypes = {
  onChange: PropTypes.func,
  employee: PropTypes.object,
  editing: PropTypes.bool
};
Vacation.defaultProps = {
  employee: {}
};
export default Vacation;
